import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * An event object.
 *
 * @typeParam T - The type of the `data` property of this event.
 */
export var EmittedEvent =
/*#__PURE__*/
function () {
  /**
   * @param type - The name of the event
   * @param data - The data that is associated with the event.
   */
  function EmittedEvent(type, data) {
    _classCallCheck(this, EmittedEvent);

    /**
     * A flag that indicates whether the `preventDefault()` method has been called
     * on this event.
     */
    this.defaultPrevented = false;
    /**
     * A flag that indicates whether the `stopImmediatePropagation()` method has
     * been called on this event.
     */

    this.immediateStopped = false;
    /**
     * A flag that indicates whether the `stopPropagation()` method has been
     * called on this event.
     */

    this.stopped = false;
    this.type = type;
    this.data = data;
  }
  /**
   * Prevents the default behaviour of this event.
   *
   * Note that whether this is respected is dependent on the emitter itself.
   */


  _createClass(EmittedEvent, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = true;
    }
    /**
     * Stops the propagation of the event.
     *
     * Note that whether this is respected is dependent on the emitter itself.
     *
     * In cases of proxied events, calling this method prevents the proxies from
     * emitting this event.
     */

  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.stopped = true;
    }
    /**
     * Stops the immediate propagation of the event.
     *
     * Event listeners are called in the order they were added. Calling this
     * method inside a listener prevents the emitter from calling listeners after
     * the current one.
     */

  }, {
    key: "stopImmediatePropagation",
    value: function stopImmediatePropagation() {
      this.immediateStopped = true;
    }
  }]);

  return EmittedEvent;
}();